// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Lt-z","innerTile":"Mt-z","heading":"Nt-z","instaTileBtn":"Ot-z","disabled":"Pt-z","instaTileElement":"Qt-z","instagramPic":"Rt-z"};